module.exports = __webpack_public_path__ + "1a8d96fe472b15828c6a2ed0db86e821.fbx";